import { createApp } from 'vue';
import { createPinia } from 'pinia';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import App from './App.vue';
import router from './router';
import { clearPageTitle, setRouteTitle } from './stores/pageTitle';

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(Antd);
app.mount('#app');

// 路由切换：清空动态覆盖标题（stores/pageTitle.js 注释）+ 写入路由基准标题
// （meta.title 由 loadPlugins 注册插件路由时透传；host 内置路由静态声明）。
// document.title 同步逻辑见 stores/pageTitle.js 的 watch。
router.afterEach((to) => {
  clearPageTitle();
  setRouteTitle(to?.meta?.title || '');
});
